module.exports = __webpack_public_path__ + "img/student3.f96fb4be.svg";